import { LoanStatusType } from '../common/LoanConstants';
import LoansSearch from './components/LoansSearch';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { LoansSummaryDashboard } from './components/LoanSummaryDashboard.tsx/LoansSummaryDashboard';
import { SectionHeaderBar } from '../../common/components/SectionHeaderBar';
import { useState, useEffect } from 'react';

export interface LoansWorkspacePageProps {
    status: LoanStatusType;
}

export const LoansWorkspacePage = ({ status }: LoansWorkspacePageProps) => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [headerActions, set_headerActions] = useState<React.ReactNode>(null);
    const statusLabel = LoanStatusType[status] ?? '';
    const title = statusLabel ? `${statusLabel} Loans` : 'Loans';
    const isDashboardEnabled = true; //TODO: Will be removed at go live
    const isDashboardApplicable = status === LoanStatusType.Outstanding && isDashboardEnabled;

    useEffect(() => {
        set_headerActions(null);
    }, [status]);

    return (
        <>
            <SectionHeaderBar title={title}>{headerActions}</SectionHeaderBar>
            {isDashboardApplicable ? (
                <TabPanel
                    focusStateEnabled={false}
                    swipeEnabled={false}
                    onSelectionChanged={(e) => {
                        const index = e.component.option('selectedIndex');
                        setActiveTabIndex(index);
                        set_headerActions(null); // reset on tab change
                    }}
                >
                    <Item title='Summary Dashboard'>
                        <LoansSummaryDashboard
                            status={status}
                            isActive={activeTabIndex === 0}
                            set_headerActions={set_headerActions}
                        />
                    </Item>
                    <Item title='Search'>
                        <LoansSearch status={status} />
                    </Item>
                </TabPanel>
            ) : (
                <LoansSearch status={status} />
            )}
        </>
    );
};
